<template>
  <div class="reportMask">
    <div><i class="fa fa-minus-circle"></i></div>
    <div>
       {{ $t('Social.ReportMask.msg') }}
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.reportMask {
  width: 100%;
  height: 100%;
  position: absolute;
  /* background-color: gray; */
  /* opacity: 0.8; */
  /* background-color: rgba(1, 0, 0, 0.5); */
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.reportMask i {
  font-size: 50px;
}
.reportMask div {
  text-align: center;
  padding: 0px 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Social/ReportMask.vue